import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useStore } from "../stores/store";
import { AccessLevel, Application, ClientStatus } from "../models/enums";
import { useMemo } from "react";

interface Props {
  accessLevel?: AccessLevel;
  application?: Application;
  status?: ClientStatus;
  allowExpired?: boolean;
}

const inventoryRoutes = [
  '/inventoryIndex',
  '/inventory/bulkOrder'
]
const coreTrackingRoutes = [  '/coreTrackingIndex',]

export default function RequireAuth({
  accessLevel,
  application,
  status,
}: Readonly<Props>) {
  const {
    userStore: {
      isLoggedIn,
      checkStatus,
      checkAccessLevel,
      checkApplication,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      user,
    },
    inventorySettingsStore: {
     inventorySettings
    },
  } = useStore();
  const location = useLocation();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const unableToAccessInv = useMemo(() => inventoryRoutes.some(iR => location.pathname.includes(iR)) && inventorySettings?.isActive === false, [inventorySettings?.isActive]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const unableToAccessCoreTrk = useMemo(() => coreTrackingRoutes.some(iR => location.pathname.includes(iR)) && inventorySettings?.enableCoreTracking === false, [inventorySettings?.enableCoreTracking]);

  if (!isLoggedIn) {
    return <Navigate to="/" state={{ from: location }} />;
  }

  if (status && !checkStatus(status)) {
    //not allowed due to statues
    return <Navigate to="/" state={{ from: location }} />;
  }

  if (accessLevel && !checkAccessLevel(accessLevel)) {
    return <Navigate to="/AccessDenied" state={{ from: location }} />;
  }

  if (application && !checkApplication(application))
    return <Navigate to="/UpgradeAccount" state={{ from: location }} />;

  if (unableToAccessInv || unableToAccessCoreTrk)
    return <Navigate to="/settings/inventory" state={{ from: location }} />;

  return <Outlet />;
}
